// import LayoutNews from "@/layouts/LayoutNews";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/dangjian",
  name: "dangjian",
  meta: {
    title: "党建工作",
    icon: require('@/assets/images/icons/dangjian.png')
  },
  component: () => import("@/views/dangjian/index.vue"),
  // component: LayoutNews,
  // redirect: "/dangjian/dongtai",
  children: [
    // {
    //   path: "dongtai",
    //   name: "dangjiandongtai",
    //   meta: {
    //     title: "党建动态",
    // icon: require('@/assets/images/icons/dangjian.png')
    //   },
    //   component: () => import("@/views/dangjian/components/dongtai.vue"),
    // },
    // {
    //   path: "jingshenwenming",
    //   name: "jingshenwenming",
    //   meta: {
    //     title: "精神文明",
    // icon: require('@/assets/images/icons/dangjian.png')
    //   },
    //   component: () => import("@/views/dangjian/components/jingshenwenming.vue"),
    // }, 
  ],
},
{
  path: "/dangjian-detail",
  name: "dangjian-detail",
  meta: {
    title: "党建工作",
    hidden: true,
    icon: require('@/assets/images/icons/dangjian.png')
  },
  component: LayoutArticle,
  redirect: "/dangjian/detail",
  children: [{
    path: "/dangjian/detail",
    name: "dangjian_detail",
    meta: {
      title: "文章详情",
      hidden: true,
    },
    component: () => import("@/views/dangjian/detail.vue"),
  },],
},
]